import { Link, Typography, useTheme } from '@mui/material';
import { Avatar } from '@mui/material';
import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PlanAuthor } from '../containers/plans/types';
import ytImage from '../assets/yt_logo_rgb_light.png';
import ytImageDark from '../assets/yt_logo_rgb_dark.png';
import igImage from '../assets/ig_glyph_black.svg';
import igImageDark from '../assets/ig_glyph_white.svg';
import pinterestImage from '../assets/pinterest_red.svg';
import pinterestImageDark from '../assets/pinterest_white.svg';
import tiktokImage from '../assets/tiktok.png';
import Linkify from 'react-linkify';
import { Link as RouterLink } from 'react-router-dom';
import { getAuthorSubtitle } from '../common/util';
import { CompanyProfile } from '../services/companies';

export const AuthorBlock = ({authorInfo}: {authorInfo: PlanAuthor}) => {
	const {i18n, t} = useTranslation();
	const locale = i18n.language;
	const theme = useTheme();
	return <Box display='flex' flexDirection='column' alignItems='center'>
		<Avatar sx={{width:64, height: 64, fontSize: 40, fontWeight: 400, mb: 2}} src={authorInfo?.imgUrl}>{authorInfo?.name?.charAt(0)}</Avatar>
		<Typography variant='h2' sx={{fontSize: 24, fontWeight: 600}}>{authorInfo?.name}</Typography>
		<Typography variant='body1' fontSize={14} color='text.secondary' sx={{mb: 2}}>{getAuthorSubtitle(authorInfo as unknown as CompanyProfile, t, locale)}</Typography>
		<Typography sx={{
			whiteSpace:'pre-line', '& > p': {m: 0},
			overflow: 'hidden',
			display: '-webkit-box',
			WebkitLineClamp: 3,
			WebkitBoxOrient: 'vertical',
			textOverflow: 'ellipsis',
			textAlign: 'center',
			maxWidth: 560,
		}}>
			<Linkify
				componentDecorator={(href, text, key) => (
					<a
						key={key}
						href={href}
						target="_blank"
						rel="noopener noreferrer"
						style={{ color: theme.palette.secondary.main, textDecoration: 'underline' }}
					>
						{text}
					</a>
				)}
			>
				{authorInfo?.bio}
			</Linkify>
		</Typography>
		{authorInfo?.profileId && <Link component={RouterLink} to={`/shop/${authorInfo?.profileId}`} sx={{mt:1, textDecoration: 'underline', cursor: 'pointer', display: 'inline-block'}}>
			{t('author.moreFromAuthor', {authorName: authorInfo?.name})}
		</Link>}
		<Box sx={{display: 'flex', gap: 2, mt: 2}}>
			{authorInfo?.ytChannelId && <Typography variant='body1' maxWidth={560} sx={{mt:2}}>
				<Link href={`https://www.youtube.com/channel/${authorInfo?.ytChannelId}`} target="_blank">
					<img src={theme.palette.mode === 'dark' ? ytImageDark : ytImage} alt="YouTube" style={{height: '16px', marginRight: '4px'}} />
				</Link>
			</Typography>}
			{authorInfo?.igChannelId && <Typography variant='body1' maxWidth={560} sx={{mt:2}}>
				<Link href={`https://www.instagram.com/${authorInfo?.igChannelId}`} target="_blank">
					<img src={theme.palette.mode === 'dark' ? igImageDark : igImage} alt="Instagram" style={{height: '24px'}} />
				</Link>
			</Typography>}
			{authorInfo?.pinterestChannelId && <Typography variant='body1' maxWidth={560} sx={{mt:2}}>
				<Link href={`https://www.pinterest.com/${authorInfo?.pinterestChannelId}`} target="_blank">
					<img src={theme.palette.mode === 'dark' ? pinterestImageDark : pinterestImage} alt="Pinterest" style={{height: '24px'}} />
				</Link>
			</Typography>}
			{authorInfo?.tiktokChannelId && <Typography variant='body1' maxWidth={560} sx={{mt:2}}>
				<Link href={`https://www.tiktok.com/${authorInfo?.tiktokChannelId}`} target="_blank">
					<img src={tiktokImage} alt="TikTok" style={{height: '24px'}} />
				</Link>
			</Typography>}
		</Box>
	</Box>;
};